class LanguageManager {
	constructor() {
		this.lang = localStorage.getItem("siteLang") || "en";

		this.apply(this.lang);
		this.bindEvents();
	}

	bindEvents() {
		window.addEventListener("languageChange", (e) => {
			this.apply(e.detail);
		});
	}

	apply(lang) {
		// 1. Save state
		this.lang = lang;
		localStorage.setItem("siteLang", lang);

		// 2. Set global attribute (IMPORTANT)
		document.documentElement.setAttribute("data-lang", lang);

		// 3. Toggle UI elements
		document.querySelectorAll("[data-lang]").forEach((el) => {
			el.style.display = el.dataset.lang === lang ? "" : "none";
		});
	}
}

export default LanguageManager;
